module.exports = __webpack_public_path__ + "static/media/extended-pna.68b278ca.svg";